var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87591 22.75H18.6631C19.2742 22.75 19.7695 22.2511 19.7695 21.6357V18.659C19.7695 18.4212 19.694 18.1896 19.5538 17.9981L16.3633 13.6371C16.0842 13.2556 16.0752 12.738 16.3409 12.3469L19.2997 7.99164C19.4256 7.80631 19.4929 7.58699 19.4929 7.36242V4.36429C19.4929 3.74888 18.9976 3.25 18.3866 3.25H7.87591C7.26488 3.25 6.76953 3.74888 6.76953 4.36429V7.34095C6.76953 7.57882 6.84511 7.81045 6.98521 8.00195L10.1583 12.339C10.4459 12.7321 10.4459 13.2679 10.1583 13.661L6.98521 17.9981C6.84511 18.1896 6.76953 18.4212 6.76953 18.659V21.6357C6.76953 22.2511 7.26488 22.75 7.87591 22.75Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHourglass);
export default __webpack_public_path__ + "static/media/icon-hourglass.2ad033f66ec25d13275f3480d200ec78.svg";
export { ForwardRef as ReactComponent };